import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { RolesEnum, RootTypeEnum, VehicleStatus, VehicletypeEnum } from '@project-management-system/shared-models';
@Entity('vehicle_request')
export class VehicleRequestEntity{
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column('int', {
        name: 'employee_id',
        nullable: false
    })
    employeeId: number;
    
    @Column('int', {
        name: 'source',
        nullable: false
    })
    source: number;


    @Column('int', {
        name: 'destination',
        nullable: false
    })
    destination: number;
    
    @Column('varchar', {
        name: 'no_of_people',
        nullable: false
    })
    noOfPeople: string;

    @Column('varchar', {
        name: 'user_contact',
        nullable: false
    })
    userContact: string;

    @Column('date', {
        name: 'vehicle_required_on',
        nullable: false
    })
    vehicleRequiredOn: Date;

    @Column('date', {
        name: 'hod_approval_date',
        nullable: true
    })
    hodApprovalDate: Date;

    @Column('date', {
        name: 'admin_approval_date',
        nullable: true
    })
    adminApprovalDate: Date;

    @Column('enum', {
        name: 'vehicle_type',
        nullable: true,
        enum:VehicletypeEnum
    })
    vehicleType: VehicletypeEnum;


    @Column('int', {
        name: 'vehicle_id',
        nullable: true
    })
    vehicleId: number;

    @Column('int', {
        name: 'slab_id',
        nullable: true
    })
    slabId: number;

    @Column('int', {
        name: 'driver_id',
        nullable: true
    })
    driverId: number;

    @Column('varchar', {
        name: 'driver_contact',
        nullable: true
    })
    driverContact: string;

    @Column('int', {
        name: 'vendor_id',
        nullable: true
    })
    vendorId: number;

    @Column('int', {
        name: 'cost',
        nullable: true
    })
    cost: number;

    @Column('int', {
        name: 'distance',
        nullable: true
    })
    distance: number;

    @Column('decimal', {
        name: "opening_kms",
        nullable: true,
    })
    openingKms: number;

    @Column('decimal', {
        name: "total_hrs",
        nullable: true,
    })
    totalHrs: number;

    @Column('decimal', {
        name: "closing_kms",
        nullable: true,
    })
    closingKms: number;

    @Column('decimal', {
        name: "total_kms",
        nullable: true,
    })
    totalKms: number;

    @Column('decimal', {
        name: "extra_hrs",
        nullable: true,
    })
    extraHrs: number;

    @Column('decimal', {
        name: "extra_hrs_charges",
        nullable: true,
    })
    extraHrsCharges: number;

    @Column('decimal', {
        name: "extra_kms",
        nullable: true,
    })
    extraKms: number;

    @Column('decimal', {
        name: "extra_kms_charges",
        nullable: true,
    })
    extraKmsCharges: number;

    @Column('decimal', {
        name: "bata",
        nullable: true,
    })
    bata: number;

    @Column('decimal', {
        name: "toll_charges",
        nullable: true,
    })
    tollCharges: number;

    @Column('decimal', {
        name: "total_amount",
        nullable: true,
    })
    totalAmount: number;

    @Column('varchar', {
        name: 'on_duty_time',
        nullable: true
    })
    onDutyTime: string;

    @Column('varchar', {
        name: 'off_duty_time',
        nullable: true
    })
    offDutyTime: string;

    @Column('varchar', {
        name: 'pick_up_time',
        nullable: true
    })
    pickUpTime: string;

    @Column('varchar', {
        name: 'remarks',
        nullable: true
    })
    remarks: string;

    @Column('enum', {
        name: 'status',
        nullable: true,
        enum:VehicleStatus
    })
    status: VehicleStatus;

    @Column('enum', {
        name: 'requested_for',
        nullable: true,
        enum:RolesEnum
    })
    requestedFor: RolesEnum;

    @Column('enum', {
        name: 'type',
        nullable: true,
        enum:RootTypeEnum
    })
    type: RootTypeEnum;

    @Column('enum', {
        name: 'trip_type',
        nullable: true,
        enum:RootTypeEnum
    })
    tripType: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @Column("varchar", {
        nullable: false,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('varchar', {
        name: 'vehicle_purpose',
        nullable: true
    })
    vehiclePurpose: string;

    @Column('int', {
        name: 'vehicle_preference',
        nullable: true
    })
    vehiclePreference: number;

    @Column('varchar', {
        name: 'vehicle_req_code',
        nullable: true
    })
    vehicleReqCode: string;

   
    
    @Column('int', {
        name: 'department_id',
        nullable: true
    })
    departmentId: number;

    
    
    @Column('int', {
        name: 'vehicle_category',
        nullable: true
    })
    vehicleCategory: number;


}